<div class="row">
  <div class="col-md-6" style="height: inherit;">
    <app-tab-dashboard-input-data-left-side></app-tab-dashboard-input-data-left-side>
  </div>
  <div class="col-md-6">
    @if (formService.isShowOtherTabs) {
      <app-tab-dashboard-input-data-right-side></app-tab-dashboard-input-data-right-side>
    }
  </div>
</div>